import { render, staticRenderFns } from "./Human.vue?vue&type=template&id=04a0bfa3&"
import script from "./Human.vue?vue&type=script&lang=ts&"
export * from "./Human.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04a0bfa3')) {
      api.createRecord('04a0bfa3', component.options)
    } else {
      api.reload('04a0bfa3', component.options)
    }
    module.hot.accept("./Human.vue?vue&type=template&id=04a0bfa3&", function () {
      api.rerender('04a0bfa3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/History/Human.vue"
export default component.exports